/**
 * Created by mac on 3/1/21
 */

const WorkerView = cc.Node.extend({
    ctor: function (worker) {
        this._super();

        this.worker = worker;
        worker.setView(this);

        const styles = cleverapps.styles.WorkerView;

        this.setLocalZOrder(10);
        this.setAnchorPoint(styles.anchorX, styles.anchorY);

        if (Map2d.currentMap.workers.canWalk() && this.initWalkingSprite) {
            this.initWalkingSprite();
        }

        this.restoreState();

        this.setMapPosition(0, 0);
    },

    cleanup: function () {
        this._super();

        this.worker.removeViewStack = (new Error()).stack;
        this.worker.removeView();
    },

    setMapPosition: function (x, y) {
        this.mapPosition = cc.p(x, y);

        const map2d = Map2d.currentMap;
        const map2dView = map2d.getMapView();

        map2d.showTile(x, y);
        map2dView.addTile(Map2d.LAYER_UNITS, x, y, this);
    },

    getMapPosition: function () {
        return this.mapPosition;
    },

    createBuildingAnimation: function (building) {
        if (!cleverapps.styles.WorkerView.buildingAnimation) {
            return;
        }

        const targetView = building.unit.onGetView();

        const json = cleverapps.skins.getSlot("worker_json") || bundles.mineable.jsons.worker_json;
        const buildingAnimation = targetView.workerAnimation = new cleverapps.Spine(json);
        buildingAnimation.setSkin(cleverapps.skins.getSlot("workerSkin") || "regular");

        buildingAnimation.setAnimation(0, "building", true);
       
        buildingAnimation.setLocalZOrder(2);

        targetView.addChild(buildingAnimation);

        buildingAnimation.setAlignment(cleverapps.styles.WorkerView.buildingAnimation);
    },

    animateAppearBuildingAnimation: function (building) {
        const targetView = building.unit.onGetView();

        if (targetView.workerAnimation) {
            const effects = this.buildingEffects(building.unit.code);
            this.composite = cleverapps.effects.fire(effects.effect);

            if (targetView.workerAnimation.hasAnimation("jump")) {
                targetView.workerAnimation.setAnimationAndIdleAfter("jump", "building");
            }
        }
    },

    createMiningAnimation: function (minable) {
        const targetView = minable.unit.onGetView();

        const json = cleverapps.skins.getSlot("worker_json", minable) || bundles.mineable.jsons.worker_json;
        const miningAnimation = targetView.workerAnimation = new cleverapps.Spine(json);

        const defaultSkin = cleverapps.Spine.hasSkin("regular", json) ? "regular" : "default";
        miningAnimation.setSkin(cleverapps.skins.getSlot("workerSkin", minable) || defaultSkin);

        const effects = this.miningEffects(minable.unit.code);
        miningAnimation.setAnimation(0, effects.animation, true);

        miningAnimation.setLocalZOrder(2);

        if (!targetView) {
            throw `no view for minable unit ${minable.unit.code} ${minable.unit.stage} ${minable.unit.x} ${minable.unit.y
            } stack - ${new Error().stack
            } removeStack - ${this.removeStack}`;
        }

        targetView.addChild(miningAnimation);

        let position = cleverapps.skins.getSlot("workerMiningAnimationStyles", minable) || cleverapps.styles.WorkerView.miningAnimation;

        const downRightPosition = cc.p(minable.unit.x + Iso.DOWN_RIGHT.x, minable.unit.y + Iso.DOWN_RIGHT.y);

        if (Map2d.currentMap.getFog(downRightPosition.x, downRightPosition.y)
            || Map2d.currentMap.isImpassableGround(downRightPosition.x, downRightPosition.y)) {
            position = cleverapps.clone(position, true);
            position.x.dx = position.x.leftDx;
            miningAnimation.setScaleX(-1);
        }
        miningAnimation.setAlignment(position);
    },

    animateAppearMiningAnimation: function (minable) {
        const targetView = minable.unit.onGetView();

        const effects = this.miningEffects(minable.unit.code);
        this.composite = cleverapps.effects.fire(effects.effect);

        if (targetView.workerAnimation.hasAnimation("jump")) {
            targetView.workerAnimation.setAnimationAndIdleAfter("jump", effects.animation);
        }
    },

    removeAnimation: function (target) {
        const targetView = target.unit.onGetView();

        if (targetView && targetView.workerAnimation) {
            if (targetView.workerAnimation.hasAnimation("jump_back")) {
                targetView.workerAnimation.setAnimation(0, "jump_back", false);
                targetView.workerAnimation.setCompleteListenerRemove();
            } else {
                targetView.workerAnimation.removeFromParent();
            }
            delete targetView.workerAnimation;
        }
        cleverapps.effects.stop(this.composite);
    },

    complete: function (target) {
        if (!target.unit.onGetView()) {
            return;
        }

        this.restoreState();

        this.hideTimer(target);
        this.removeAnimation(target);
    },

    restoreState: function () {
        if (this.sprite) {
            if (this.worker.path) {
                this.setVisible(true);
            } else if (this.worker.position) {
                this.setVisible(true);
                this.restorePosition(this.worker.position);

                if (this.worker.unit) {
                    this.animateWorking(true);
                } else {
                    this.animateIdle();
                }
            } else {
                this.setVisible(false);
            }
        }

        const unitView = this.worker.unit && this.worker.unit.onGetView();
        if (!unitView) {
            return;
        }

        const workable = this.worker.unit.findComponent(Mineable) || this.worker.unit.findComponent(Buildable);

        if (!this.sprite && !unitView.workerAnimation) {
            if (workable instanceof Buildable) {
                this.createBuildingAnimation(workable);
            } else {
                this.createMiningAnimation(workable);
            }
        }

        if (this.worker.getTimeLeft() <= 0) {
            this.hideTimer(workable, true);
        } else {
            this.createTimer(workable);
        }
    },

    restorePosition: function (cell) {
        const mapView = Map2d.currentMap.getMapView();

        this.setPosition(mapView.alignInGrid(cell.x, cell.y));
        this.setMapPosition(Math.round(cell.x), Math.round(cell.y));
    },

    startWorking: function (target) {
        target.onUpdateState();

        this.animateWorking();

        const targetView = target.unit.onGetView();
        if (targetView) {
            if (!this.sprite) {
                if (target instanceof Buildable) {
                    this.animateAppearBuildingAnimation(target);
                } else {
                    this.animateAppearMiningAnimation(target);
                }
            }

            this.animateAppearTimer(target);
        }
    },

    createTimer: function (workable) {
        this.hideTimer(workable, true);
        const targetView = workable.unit.onGetView();
        const timer = new WorkerComponentTimer(this.worker);
        timer.setAlignment(cleverapps.styles.WorkerView.timer);
        targetView.createAdditionalView("timer", timer);
    },

    animateAppearTimer: function (workable) {
        const targetView = workable.unit.onGetView();
        const view = targetView.getAdditionalView("timer");
        if (view) {
            view.animateAppear();
        }
    },

    hideTimer: function (workable, silent) {
        const targetView = workable.unit.onGetView();
        targetView.removeAdditionalView("timer", this.worker.speedupInProgress, silent);
    },

    showSpeedUp: function (unit, time, callback) {
        const unitView = unit.onGetView();
        const timer = unitView && unitView.getAdditionalView("timer");

        if (timer) {
            timer.view.showBoost({
                limit: time,
                duration: Workers.BOOST_ANIMATE_DURATION,
                callback
            });
        } else {
            callback();
        }
    },

    miningEffects: function (code) {
        const effects = cleverapps.skins.getSlot("miningEffects");
        if (effects) {
            return effects;
        }

        const useSingleAnimation = cleverapps.styles.WorkerView.useSingleMiningAnimation;

        switch (code) {
            case "bamboosource":
            case "bamboo":
            case "drwoodsource":
            case "drwood":
            case "woodsource":
            case "wood": return {
                animation: "chop",
                effect: "mining.wood.start"
            };
            case "advrock":
            case "drstonesource":
            case "drstone":
            case "stonesource":
            case "stone": return {
                animation: useSingleAnimation ? "chop" : "chop2",
                effect: "mining.stone.start"
            };
            case "drcastlesource":
            case "drcastle":
            case "drwagon":
            case "drsledsource":
            case "drsled":
            case "drpurplecrystalsource":
            case "drpurplecrystal":
            case "wagonsource":
            case "wagon": return {
                animation: useSingleAnimation ? "chop" : "chop2",
                effect: [
                    `mining.start.${code}`,
                    "mining.wagon.start"
                ]
            };
        }

        return {
            animation: "chop",
            effect: [
                `mining.start.${code}`,
                "mining.start"
            ]
        };
    },

    buildingEffects: function (code) {
        return this.miningEffects(code);
    },

    // Stub methods for non-walking workers - overridden by walkingworkerview.js
    animateWorking: function () {},
    animateIdle: function () {}
});

cleverapps.styles.WorkerView = {
    anchorX: 0.54,
    anchorY: 0.11,

    speed: {
        walk: {
            value: 400
        },
        run: {
            value: 850,
            soundCoefficient: 1.8
        }
    },

    timer: {
        x: { align: "center", dx: 10 },
        y: { align: "center", dy: -29 }
    },

    miningAnimation: {
        x: { align: "center", dx: 90, leftDx: -45 },
        y: { align: "bottom", dy: 0 }
    },

    buildingAnimation: {
        x: { align: "center", dx: 70 },
        y: { align: "bottom", dy: 0 }
    }
};